import { SideDrawerContent } from 'actions/types/SideDrawerActionTypes';
import { RootState } from '../reducers';

export const getSideDrawerContent = (state: RootState): SideDrawerContent | null => {
  return state.sideDrawer.content;
};
